import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ApiAgent } from 'sprites-types/api/agents'
import { Steps } from 'sprites-types/api/steps'

export type BackImagesPosition = 'top' | 'center' | 'bottom'
interface AgentState {
  agent: ApiAgent | null
  steps: Steps | null
  agentDeployed: boolean
}

export const initialState: AgentState = {
  agent: null,
  steps: null,
  agentDeployed: false,
}

const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    setAgent: (state: AgentState, action: PayloadAction<ApiAgent | null>) => {
      state.agent = action.payload
    },
    updateAgent: (state: AgentState, action: PayloadAction<Partial<ApiAgent>>) => {
      if (state.agent) {
        state.agent = { ...state.agent, ...action.payload }
      }
    },
    setAgentSteps: (state: AgentState, action: PayloadAction<Steps | null>) => {
      state.steps = action.payload
    },
    setAgentDeployed: (state: AgentState, action: PayloadAction<boolean>) => {
      state.agentDeployed = action.payload
    },
    resetAgentState: (state: AgentState) => {
      state.agent = null
      state.steps = null
      state.agentDeployed = false
    },
  },
})

export const { setAgent, updateAgent, setAgentSteps, setAgentDeployed, resetAgentState } =
  agentSlice.actions

export default agentSlice.reducer
